import React from "react";
import { FiMoon, FiSun } from "react-icons/fi";
import { ThemeToggleButton } from "./styles";

export default function AuthThemeToggle({ authTheme, onToggleAuthTheme }) {
  const isNight = authTheme === "night";
  const label = isNight ? "切換日間模式" : "切換夜間模式";
  return (
    <ThemeToggleButton type="button" aria-label={label} title={label}
      aria-pressed={isNight} onClick={onToggleAuthTheme}>
      {isNight ? <FiSun aria-hidden="true" /> : <FiMoon aria-hidden="true" />}
    </ThemeToggleButton>
  );
}
